import { commonEndpoints } from './common.endpoints'
import { jplEndpoints } from './jpl.endpoints'
import { pocEndpoints } from './poc.endpoints'

export const endpoints = {
    common: commonEndpoints,
    jpl: jplEndpoints,
    poc: pocEndpoints,
}
